const AnalyticsEmptyState = ({
  title = "No analytics data found",
  description = "Try adjusting the current search filters",
}: {
  title?: string;
  description?: string;
}) => (
  <div className="flex max-h-full w-full max-w-sm flex-col items-center justify-center overflow-hidden px-4 py-3 text-center sm:px-6 sm:py-4">
    <img
      src="/analytics_no_data.gif"
      alt=""
      className="mb-2 h-auto max-h-20 w-auto max-w-[min(10rem,70vw)] shrink object-contain opacity-70 sm:mb-3 sm:max-h-28 lg:max-h-32"
      aria-hidden="true"
      draggable={false}
    />
    <div className="mb-1 text-sm font-medium leading-5 text-gray-700">{title}</div>
    <div className="max-w-xs text-xs leading-4 text-gray-500">{description}</div>
  </div>
);

export default AnalyticsEmptyState;
